import { Component, OnInit, OnDestroy } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { NavigationService } from "./_services/navigation.service";
import { UserService } from "./_services/user.service";
import { SecurityService } from "./_services/security.service";

import { Subscription } from "rxjs";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit, OnDestroy {
  public navigation: string;
  private client: boolean;
  private transporter: boolean;
  private admin: boolean;
  private subscriptions: Subscription[] = [];

  constructor(
    private router: Router,
    private navigationService: NavigationService,
    private userService: UserService,
    private securityService: SecurityService) { }

  title = "app";

  ngOnInit() {

    this.subscriptions.push(
      this.navigationService.navigation$.subscribe((navState) => {
        this.navigation = navState;
      })
    );
    this.subscriptions.push(
      this.userService.client$.subscribe((isClient) => {
        this.client = isClient;
        //console.log(`Client status updated: ${this.client}`);
      })
    );
    this.subscriptions.push(
      this.userService.transporter$.subscribe((isTransporter) => {
        this.transporter = isTransporter;
        //console.log(`Transporter status updated: ${this.transporter}`);
      })
    );
    this.subscriptions.push(
      this.userService.admin$.subscribe((isAdmin) => {
        this.admin = isAdmin;
       // console.log(`Admin status updated: ${this.admin}`);
      })
    );
    this.subscriptions.push(
      this.securityService.user$.subscribe((user) => {
        if (user) {
          this.setUserRole(user.role);
        }
      })
    )

    this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd) {
      //  this.navigationService.updateState();
      }
    })
  }
  ngOnDestroy() {
    if (this.subscriptions) {
      this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
  }
  isLoginRoute(): boolean {
    return this.router.url === '/login';
  }

  isTransportDetailsRoute(): boolean {
    return this.router.url.includes('/transport-details');
  }
  
  isDeliveryDetailsRoute(): boolean {
    return this.router.url.includes('/delivery-details');
  }

  isTransportInterestRoute(): boolean {
    return this.router.url.includes('/transport-interest');
  }

  setUserRole(role: 'client' | 'transporter' | 'admin') {

    this.userService.setClient(role === 'client');
    this.userService.setTransporter(role === 'transporter');
    this.userService.setAdmin(role === 'admin');
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/app.component.ts